import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const Expenses = ({ onTotalExpensesChange }) => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const navigate = useNavigate();

    const [fetchedData, setFetchedData] = useState([]);
    const [totalExpenses, setTotalExpenses] = useState(0);

    {/**useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);
    
    useEffect(() => {
        const fetchProfile = async () => {
            if (!token) return; // Exit if no token
    
            try {
                const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUser(response.data);
            } catch (error) {
                console.log('');
            }
        };
    
        fetchProfile();
    }, [token]);*/}

    useEffect(() => {
        const fetchProfile = async () => {
          const token = localStorage.getItem("token");
    
          if (!token) {
            navigate("/"); // Redirect if no token
            return;
          }
    
          try {
            const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
              headers: { Authorization: `Bearer ${token}` },
            });
            setUser(response.data);
          } catch (error) {
            if (error.response && error.response.status === 401) {
              localStorage.removeItem("token");
              navigate("/"); // Redirect on 401 error
            }
          }
        };
    
        fetchProfile();
      }, []);

    useEffect(() => {
        if (user.id) {
            fetchData();
        }
    }, [user.id]);


    const fetchData = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-expense-data');
            if (user.id) {
                {/**console.log('console.log("");:', user.id);*/}
                const Expenses = response.data.filter(expense =>
                    expense.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setFetchedData(Expenses);
            }
        } catch (error) {
            console.error('Error fetching expenses data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
    let total = 0;
    const currentMonth = new Date().getMonth() + 1; // Get current month (1-based)
    const currentYear = new Date().getFullYear(); // Get current year

    fetchedData.forEach(expense => {
        const expenseDate = new Date(expense.date); // Assuming `expense.date` is a valid date string

        if (expenseDate.getMonth() + 1 === currentMonth && expenseDate.getFullYear() === currentYear) {
            expense.items.forEach(item => {
                total += Number(item.amount); // Ensure item.amount is treated as a number
            });
        }
    });

    setTotalExpenses(total);

    // Call the callback if it exists
    if (onTotalExpensesChange) {
        onTotalExpensesChange(total);
    }
}, [fetchedData, onTotalExpensesChange]);

    

    // Return null to render nothing in the component
    return null;
};

export default Expenses;
